var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.146445 3.11716C2.98023e-08 3.23432 0 3.42288 0 3.8V6.2C0 6.57712 2.98023e-08 6.76568 0.146445 6.88284C0.292895 7 0.528595 7 1 7C1.47141 7 1.7071 7 1.85355 6.88284C2 6.76568 2 6.57712 2 6.2V3.8C2 3.42288 2 3.23432 1.85355 3.11716C1.7071 3 1.47141 3 1 3C0.528595 3 0.292895 3 0.146445 3.11716Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14645 0.120602C6 0.241208 6 0.435314 6 0.823529V6.17647C6 6.56468 6 6.75879 6.14645 6.87939C6.2929 7 6.5286 7 7 7C7.4714 7 7.7071 7 7.85355 6.87939C8 6.75879 8 6.56468 8 6.17647V0.823529C8 0.435314 8 0.241208 7.85355 0.120602C7.7071 2.45431e-08 7.4714 0 7 0C6.5286 0 6.2929 2.45431e-08 6.14645 0.120602Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.85714C3 1.45308 3 1.25105 3.14645 1.12552C3.2929 1 3.5286 1 4 1C4.4714 1 4.7071 1 4.85355 1.12552C5 1.25105 5 1.45308 5 1.85714V6.14286C5 6.54691 5 6.74894 4.85355 6.87447C4.7071 7 4.4714 7 4 7C3.5286 7 3.2929 7 3.14645 6.87447C3 6.74894 3 6.54691 3 6.14286V1.85714Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.307692 8C0.13776 8 0 8.22387 0 8.5C0 8.77613 0.13776 9 0.307692 9H7.69231C7.86224 9 8 8.77613 8 8.5C8 8.22387 7.86224 8 7.69231 8H0.307692Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c8cf421968b1446d1beafd449a153391.svg";
export { ForwardRef as ReactComponent };